module.exports = __webpack_public_path__ + "/img/Chip-Led-Labeled-zaktBH.svg";